import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;
const fileName = import.meta.url.split("/").pop().split(".")[0];

class AdvertisementService {
    saveAdvertisements(body) {
        const ruta = `${API_URL}/${fileName}`;
        return axios.post(ruta, body, {
            headers: {
                ...headerRequest(),
                "Content-Type": "multipart/form-data",
            },
        }).catch((error) => {
            return error;
        });
    }

    getAdvertisements({ page = 1, fechaIni, fechaFin, nmbNormal_NmbCorto, trabajador,carpetaArea_id}) {
        const ruta = `${API_URL}/${fileName}`;
        const params = { page, fechaIni, fechaFin, nmbNormal_NmbCorto, trabajador,carpetaArea_id };
        return axios.get(ruta, {
            headers: headerRequest(),
            params: params
        }).catch((error) => {
            return error;
        });
    }


    async downloadAdvertisement(body) {
        const ruta = `${API_URL}/${fileName}/download`;
        return axios.post(ruta, body, {
            headers: headerRequest(),
            responseType: 'blob'
        }).catch((error) => {
            return error;
        });
    }

    deleteAdvertisement(id_Advertisement) {
        const ruta = `${API_URL}/${fileName}`;
        return axios.delete(ruta, {
            headers: headerRequest(),
            data: { id_anuncio: id_Advertisement }
        }).catch((error) => {
            return error;
        });
    }


    getCarpeta() {
        const ruta = `${API_URL}/${fileName}/carpeta-area`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }

    saveCarpeta(body) {
        const ruta = `${API_URL}/${fileName}/crear-carpeta`;
        return axios.post(ruta, body, {
            headers: {
                ...headerRequest(),
                "Content-Type": "multipart/form-data",
            },
        }).catch((error) => {
            return error;
        });
    }

    getJefeCarpeta() {
        const ruta = `${API_URL}/${fileName}/carpeta-jefe`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }

    getUsersByCarpeta({carpetaArea_id}) {
        const ruta = `${API_URL}/${fileName}/carpeta-user`;
        const params = {carpetaArea_id };
        return axios.get(ruta, {
            headers: headerRequest(),
            params: params
        }).catch((error) => {
            return error;
        });
    }

    
    saveUsersByCarpeta(body) {
        const ruta = `${API_URL}/${fileName}/crear-carpeta-user`;
        return axios.post(ruta, body, {
            headers: {
                ...headerRequest(),
                "Content-Type": "multipart/form-data",
            },
        }).catch((error) => {
            return error;
        });
    }

    
    deleteUserFromCarpeta(data) {
        const ruta = `${API_URL}/${fileName}/user-delete`;
        return axios.delete(ruta, {
          data, // <- cuerpo con persona_id y carpetaArea_id
          headers: {
            ...headerRequest(),
          },
        }).catch((error) => {
          return error;
        });
      }
      
}

export default new AdvertisementService();